import type { AssetVersionsGalleryLabels } from "@/components/media/asset-versions-gallery"
import { useTranslation } from "@/hooks/use-translation"

/** Подписи галереи медиа-версий (портрет / видео героя, версии ноды флоу). */
export function useMediaGalleryLabels(): AssetVersionsGalleryLabels {
  const { t } = useTranslation(["workspace", "common", "location"])
  return {
    active: t("charactersPage.mediaGalleryActive"),
    noPreview: t("charactersPage.mediaGalleryNoPreview"),
    uploaded: t("charactersPage.mediaGalleryUploaded"),
    generated: t("charactersPage.mediaGalleryGenerated"),
    cleared: t("charactersPage.mediaGalleryCleared"),
    correct: t("charactersPage.correct"),
    delete: t("charactersPage.delete"),
    doubleClickActivate: t("references.doubleClickActivate", { ns: "location" }),
    loading: t("charactersPage.mediaGalleryLoading"),
    empty: t("charactersPage.mediaGalleryEmpty"),
    close: t("close", { ns: "common" }),
  }
}
